import React from "react";

const TopoIcone = ({ icone }) => {
  return (
    <div style={{
      position: "absolute",
      top: "0.45rem",
      right: "0.75rem",
      width: "36px",
      height: "36px",
      borderRadius: "50%",
      backgroundColor: "#d1f5e1",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      zIndex: 100
    }}>
      {icone}
    </div>
  );
};

export default TopoIcone;
